import { Profile } from '~/helpers/userProfile';
import { defaultMultipleConfigOptions, healthRemoteControlOption } from '~/components/NewTable/multipleConfigOptions';
import { MultipleConfigOption } from '~/components/NewTable/types';
import { PanelClientId, isHealthRemoteControlOnlyEdit, isRegistryEditRestricted } from './registryEdit';

type Translate = Parameters<typeof defaultMultipleConfigOptions>[0];
type Supervisors = Parameters<typeof defaultMultipleConfigOptions>[1];

export interface UnitsMultipleConfig {
  // undefined mantém a regra padrão da tabela (só quem gerencia todos os clientes seleciona em lote).
  canSelectMultiple: boolean | undefined;
  options: MultipleConfigOption[];
}

// Ações de "Múltiplas Configurações" da tabela de unidades por perfil no cliente aberto no Painel.
export function getUnitsMultipleConfig(
  profile: Profile,
  clientId: PanelClientId,
  t: Translate,
  supervisors?: Supervisors,
): UnitsMultipleConfig {
  if (isRegistryEditRestricted(profile, clientId)) {
    const responsibleOption = defaultMultipleConfigOptions(t, supervisors).filter((option) => option.value === 'setResponsible');
    return { canSelectMultiple: true, options: [...responsibleOption, healthRemoteControlOption(t)] };
  }
  if (isHealthRemoteControlOnlyEdit(profile, clientId)) {
    return { canSelectMultiple: true, options: [healthRemoteControlOption(t)] };
  }
  return { canSelectMultiple: undefined, options: defaultMultipleConfigOptions(t, supervisors) };
}
